
import React from 'react';
import {DashboardContainer, Spinner} from "../../funcs/utils";
import { loadStatement } from "../../dashboard/user/actions";
import ReactTable from "react-table";
import { sprintf } from "sprintf-js";
import {StatementTypes} from "../../../lib/statement-constants";
import { saveAs } from 'file-saver';
import {b64toBlob} from "../../../lib/memory";
import {DEVICE_WIDTH} from "../../../lib/constants";

const CELL_STYLE = {
  textAlign: "center",
  //fontFamily: "monospace",
}

const LEFT_ARROW = (<i className="fa fa-arrow-left" aria-hidden="true"/>);
const RIGHT_ARROW = (<i className="fa fa-arrow-right" aria-hidden="true"/>);

const OP = {
  DOWNLOAD: "DOWNLOAD",
  VIEW: "VIEW",
}

class Statements extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      current_year: "",
    };
  }

  componentDidMount = () => {
    const dashboard = this.props.dashboard;
    const acct_index = this.props.args.acct_index;
    if (!dashboard
      || !dashboard.monthly
      || !dashboard['1099']
      || !dashboard.trade_confirmations) {
      this.props.userLoadStatements(acct_index, this.props.username);
    }
  }

  downloadStatement = (year, month, op, filename, file_type) => {
    this.setState({
      loading: { year, month, op, file_type }
    });
    loadStatement(
      this.props.user.token, file_type, year, month,
      parseInt(this.props.args.acct_index, 10),
      this.props.username)
      .then(result => {
        this.setState({
          loading: {},
        });
        if (op === OP.DOWNLOAD) {
          saveAs(b64toBlob(result.pdf), filename);
        }
      })
  }

  renderMonthlyDownloadCell = row => {
    const filename = sprintf(
      "monthly_%04d_%02d.pdf", row.original.year, row.original.month);
    const on_click = () => {
      this.downloadStatement(
        row.original.year, row.original.month, OP.DOWNLOAD, filename, StatementTypes.MONTHLY);
    }

    const loading = this.state.loading;
    const is_loading = loading
      && loading.year === row.original.year
      && loading.month === row.original.month
      && loading.op === OP.DOWNLOAD
      && loading.file_type === StatementTypes.MONTHLY;

    const text = is_loading
      ? (<Spinner/>)
      : (<a onClick={on_click}>{filename}</a>);

    return (
      <div style={CELL_STYLE}>
        { text }
      </div>);
  }

  render1099DownloadCell = row => {
    const filename = sprintf("1099_%04d.pdf", row.original.year);
    const on_click = () => {
      this.downloadStatement(
        row.original.year, 0, OP.DOWNLOAD, filename,
        StatementTypes['1099']);
    }
    const loading = this.state.loading;
    const is_loading = loading
      && loading.year === row.original.year
      && loading.op === OP.DOWNLOAD
      && loading.file_type === StatementTypes['1099'];
    const text = is_loading
      ? (<Spinner/>)
      : (<a onClick={on_click}>{filename}</a>);

    return (
      <div style={CELL_STYLE}>
        { text }
      </div>);
  }

  center = row => {
    return (<div style={CELL_STYLE}>{row.value}</div>)
  }

  renderYearHeader = (data, current_year, statement_type) => {
    const do_medium = this.props.app.width < DEVICE_WIDTH.medium;

    const has_future = data.filter(
      item => item.year === current_year + 1).length > 0;
    const has_past = data.filter(
      item => item.year === current_year - 1).length > 0;
    const padding = "2rem";
    const on_left = () => {
      this.props.setStatementCurrentYear(
        this.props.username, this.props.acct_index, statement_type, current_year - 1);
    }
    const on_right = () => {
      this.props.setStatementCurrentYear(
        this.props.username, this.props.acct_index, statement_type, current_year + 1);
    }

    const left_arrow = (
      <span style={{paddingRight: padding }}>
        { has_past ? <a onClick={on_left}>{LEFT_ARROW}</a> : LEFT_ARROW }
      </span>);
    const right_arrow = (
      <span style={{paddingLeft: padding}}>
        { has_future ? <a onClick={on_right}>{RIGHT_ARROW}</a> : RIGHT_ARROW }
      </span>);

    const monthly_style = {
      fontSize: do_medium ? "1rem" : "2rem",
      paddingBottom: "1rem",
    }

    return (
      <div align={"center"} style={monthly_style}>
        { left_arrow }
        <span>{current_year}</span>
        { right_arrow }
      </div>
    )
  }


  renderMonthlyTable = () => {
    const dashboard = this.props.dashboard;
    if (!dashboard || !dashboard.monthly) {
      return null;
    }

    const data = dashboard.monthly.filter(
      item => item.year === dashboard.current_year);

    return (
      <div>
        { this.renderYearHeader(
          dashboard.monthly,
          dashboard.current_year,
          StatementTypes.MONTHLY) }
        <div className="data-table">
          <ReactTable
            data={data}
            pageSize={data.length}
            showPagination={false}
            className="-striped -highlight"
            columns={[
              {
                Header: "Date",
                id: "date",
                accessor: item => sprintf("%02d-01-%04d", item.month, item.year),
                Cell: this.center,
              },
              {
                Header: "Download",
                id: "download",
                Cell: this.renderMonthlyDownloadCell,
              }
            ]}
            />
        </div>
      </div>
    );
  }

  render1099Table = () => {
    const dashboard = this.props.dashboard;
    if (!dashboard || !dashboard['1099']) {
      return null;
    }

    const data = dashboard['1099'];

    return (
      <div>
        <div className="data-table">
          <ReactTable
            data={data}
            pageSize={data.length}
            showPagination={false}
            className="-striped -highlight"
            columns={[
              {
                Header: "Year",
                id: "year",
                accessor: item => sprintf("%04d", item.year),
                Cell: this.center,
              },
              {
                Header: "Download",
                id: "download",
                Cell: this.render1099DownloadCell,
              }
            ]}
          />
        </div>
      </div>
    );
  }

  renderTradeConfirmationTable = () => {
    const dashboard = this.props.dashboard;
    if (!dashboard || !dashboard.trade_confirmations) {
      return null;
    }

    // Filter for the current year
    const items = dashboard.trade_confirmations.filter(
      item => item.year === dashboard.current_year);
    // Get the embedded item
    const data = items.map(item => item.item);

    data.forEach(line => {
      const price = parseFloat(line.Price);
      line.price = sprintf("%.02f", price);
    })

    const cols = [
      { header: "Account Number", id: "account_number", prop: "AccountNumber" },
      { header: "Order Type", id: "order_type", prop: "OrderType" },
      { header: "Price", id: "price", prop: "price" },
      { header: "Quantity", id: "quantity", prop: "Quantity" },
      { header: "Symbol", id: "sym", prop: "Symbol" },
      { header: "Security", id: "security", prop: "SecDescLine1" },
      { header: "Trade Date", id: "trade", prop: "TradeDate" },
      { header: "Settlement Date", id: "settlement", prop: "SettlementDate" },
      { header: "Transaction", id: "transaction", prop: "TransactionNumber" },
      { header: "Gross Amt", id: "gross", prop: "GrossAmount" },
      { header: "Net Amt", id: "net", prop: "NetAmount" },
    ]

    const gen_column = col => {
      return {
        Header: col.header,
        id: col.id,
        accessor: item => item[col.prop],
        Cell: this.center,
      }
    }
    return (
      <div>
        { this.renderYearHeader(
          dashboard.trade_confirmations,
          dashboard.current_year,
          StatementTypes.TRADE_CONFIRMATIONS) }
        <div className="data-table">
          <ReactTable
            data={data}
            pageSize={data.length}
            showPagination={false}
            className="-striped -highlight"
            columns={cols.map(gen_column)}
          />
        </div>
      </div>
    );
  }

  render = () => {

    const client = this.props.client;
    const loading = this.props.userDashboard.loading;
    const device = {
      width: this.props.app.width,
    }

    return (
      <div id={"statements"}>
        <DashboardContainer
          title={"Monthly Statements"}
          client={client}
          device={device}
          spinner={loading}>
          { this.renderMonthlyTable() }
        </DashboardContainer>
        <DashboardContainer
          title={"1099"}
          client={client}
          device={device}
          spinner={loading}>
          { this.render1099Table() }
        </DashboardContainer>
      </div>
    )
  }
}

export { Statements };
